import { get } from "../api";
import { COUNTRY_LIST_URL } from "../utils/url";

export const getCountryList = () => {
  return get(COUNTRY_LIST_URL, false);
}
